'use client';

import type { FC } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button, SEAM } from '@/components/ui/button/button';
import { cn } from '@/utils/cn';

/** The gallery's seam-joined chevrons, driving whichever lane is selected. */
export const AuctionBoardArrows: FC<{
  label: string;
  atStart: boolean;
  atEnd: boolean;
  onPrev: () => void;
  onNext: () => void;
}> = ({ label, atStart, atEnd, onPrev, onNext }) => (
  <nav aria-label={`Przewijanie: ${label}`} className="ml-auto hidden shrink-0 items-stretch sm:inline-flex">
    <Button
      iconOnly
      size="sm"
      variant={atStart ? 'ghost' : 'primary'}
      disabled={atStart}
      aria-label="Przesuń w lewo"
      startIcon={<ChevronLeft size={20} aria-hidden />}
      className={cn(SEAM.icon.prev, atStart && SEAM.off)}
      onClick={onPrev}
    />
    <Button
      iconOnly
      size="sm"
      variant={atEnd ? 'ghost' : 'primary'}
      disabled={atEnd}
      aria-label="Przesuń w prawo"
      startIcon={<ChevronRight size={20} aria-hidden />}
      className={cn(SEAM.icon.next, atEnd && SEAM.off)}
      onClick={onNext}
    />
  </nav>
);
